module.exports = __webpack_public_path__ + "static/media/mall-discount-bg-green.4dce7e98.svg";